import {
  categorySchema,
  type IActivityCategory,
} from "@medoma/models/activities";
import styles from "./CategoryIcon.module.scss";
import clsx from "clsx";
import HouseIcon from "@medoma/components/icons/HouseIcon";
import VideoCameraIcon from "@medoma/components/icons/VideoCameraIcon";
import AvatarIcon from "@medoma/components/icons/AvatarIcon";
import MedicalCircleIcon from "@medoma/components/icons/MedicalCircleIcon";
import HealthParametersIcon from "@medoma/components/icons/HealthParametersIcon";
import BulletListIcon from "@medoma/components/icons/BulletListIcon";
import PenIcon from "@medoma/components/icons/PenIcon";
import PhoneIcon from "@medoma/components/icons/PhoneIcon";

type ICategoryIcon = {
  category: IActivityCategory | "MultipleCategories";
  size?: "small" | "medium" | "tiny";
};

export const CategoryIcon = ({ category, size = "medium" }: ICategoryIcon) => {
  const renderIcon = () => {
    switch (category) {
      case categorySchema.enum.HomeVisit:
        return <HouseIcon />;
      case categorySchema.enum.VideoCall:
        return <VideoCameraIcon />;
      case categorySchema.enum.ClinicVisit:
        return <MedicalCircleIcon />;
      case categorySchema.enum.PatientTask:
        return <AvatarIcon />;
      case categorySchema.enum.AdminTask:
        return <PenIcon />;
      case categorySchema.enum.PatientMeasurementTask:
        return <HealthParametersIcon />;
      case categorySchema.enum.PhoneCall:
        return <PhoneIcon />;
      case "MultipleCategories":
        return <BulletListIcon />;
      default:
        throw category satisfies never;
    }
  };

  return (
    <div
      className={clsx([
        styles.container,
        styles[`category-${category}`],
        styles[`size-${size}`],
      ])}
    >
      {renderIcon()}
    </div>
  );
};
